subLineIndex